import React from 'react';

const StudentManagement = ({ students, onStudentSelect }) => {
  const getElectiveColor = (subject) => {
    const colors = {
      '生物': 'bg-green-100 text-green-800',
      '化學': 'bg-blue-100 text-blue-800',
      '物理': 'bg-purple-100 text-purple-800',
      '歷史': 'bg-yellow-100 text-yellow-800',
      '地理': 'bg-teal-100 text-teal-800',
      '數學延伸': 'bg-pink-100 text-pink-800'
    };
    return colors[subject] || 'bg-gray-100 text-gray-800';
  };

  const getClassLevelColor = (classId) => {
    const level = parseInt(classId.charAt(0));
    const colors = {
      1: 'bg-blue-100 text-blue-800',
      2: 'bg-green-100 text-green-800',
      3: 'bg-yellow-100 text-yellow-800',
      4: 'bg-purple-100 text-purple-800',
      5: 'bg-pink-100 text-pink-800',
      6: 'bg-red-100 text-red-800'
    };
    return colors[level] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="student-management">
      <div className="section-header">
        <h2>學生管理</h2>
        <p>管理學生資料和選修科目</p>
      </div>

      <div className="students-grid">
        {students.map((student) => (
          <div 
            key={student.id} 
            className="student-card"
            onClick={() => onStudentSelect(student)}
          >
            <div className="student-card-header">
              <div className="student-avatar">
                <span className="avatar-text">
                  {student.student_name.charAt(0)}
                </span>
              </div>
              <div className="student-info">
                <h3 className="student-name">{student.student_name}</h3>
                <p className="student-id">學號: {student.student_id}</p>
              </div>
              <div className={`class-badge ${getClassLevelColor(student.class_id)}`}>
                {student.class_id}
              </div>
            </div>

            <div className="student-details">
              <div className="detail-item">
                <span className="detail-label">班級:</span>
                <span className="detail-value">{student.class_id}</span>
              </div>
              
              {student.elective_subjects && student.elective_subjects.length > 0 && (
                <div className="detail-item">
                  <span className="detail-label">選修科目:</span>
                  <div className="electives-list">
                    {student.elective_subjects.map((subject, index) => (
                      <span 
                        key={index} 
                        className={`elective-tag ${getElectiveColor(subject)}`}
                      >
                        {subject}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {(!student.elective_subjects || student.elective_subjects.length === 0) && (
                <div className="detail-item">
                  <span className="detail-label">課程類型:</span>
                  <span className="detail-value">核心科目</span>
                </div>
              )}
            </div>

            <div className="student-actions">
              <button className="action-btn primary">
                📅 查看時間表
              </button>
            </div>
          </div>
        ))}
      </div>

      {students.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">👨‍🎓</div>
          <h3>暫無學生資料</h3>
          <p>請檢查資料庫連接或聯繫系統管理員</p>
        </div>
      )}
    </div>
  );
};

export default StudentManagement;
